module.exports = __webpack_public_path__ + "img/shopping-bag-line.b59914cd.svg";